import { render, staticRenderFns } from "./BarrelUpgradeRecord.vue?vue&type=template&id=02119f3c&scoped=true&"
import script from "./BarrelUpgradeRecord.vue?vue&type=script&lang=ts&"
export * from "./BarrelUpgradeRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02119f3c",
  null
  
)

export default component.exports